// extracted by mini-css-extract-plugin
export default {"termCode":"LedgerAccountSelect_termCode__P0KpR","fundType":"LedgerAccountSelect_fundType__XzHAc"};